import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styles from "./SecaoItens.module.css";
import CardItem from "./CardItem";
import { FaSearch } from "react-icons/fa";


function SecaoItens({ categoriaSelecionada, textoFiltrado, idEstabelecimento }) {
  const { id: idFromParams } = useParams(); // <-- pega o id da URL
  const [produtos, setProdutos] = useState([]);

  // Usar idEstabelecimento passado por prop, da URL, ou do localStorage
  const id = idEstabelecimento || idFromParams || localStorage.getItem("estabelecimento_id");

  console.log('🔍 [SECAO ITENS] ID do estabelecimento:', {
    prop: idEstabelecimento,
    url: idFromParams,
    localStorage: localStorage.getItem("estabelecimento_id"),
    usado: id
  });

  const adicionarAoCarrinho = (item) => {
    let carrinho = JSON.parse(localStorage.getItem("carrinho")) || [];
    const itemComIdUnico = { ...item, uuid: Date.now() + Math.random() };
    carrinho.push(itemComIdUnico);
    localStorage.setItem("carrinho", JSON.stringify(carrinho));

    // Salvar o estabelecimento_id no localStorage
    if (item.id_estabelecimento) {
      localStorage.setItem('estabelecimento_id', item.id_estabelecimento);
      console.log('✅ [CARRINHO] estabelecimento_id salvo no localStorage:', item.id_estabelecimento);
      // Disparar evento para conectar SSE
      window.dispatchEvent(new CustomEvent('estabelecimentoChanged', {
        detail: { estabelecimentoId: item.id_estabelecimento }
      }));
    }

    // Disparar evento para atualizar o contador do carrinho
    window.dispatchEvent(new Event("carrinhoAtualizado"));

    alert(`${item.label_title} foi adicionado ao carrinho!`);
  };

  const fetchProdutos = async () => {
    try {
      const API_URL = process.env.REACT_APP_API_URL;

      // Se temos o id do estabelecimento da URL, buscar apenas produtos desse estabelecimento
      let url = `${API_URL}/cadastroprodutos`;
      if (id) {
        url = `${API_URL}/cadastroprodutos?id_estabelecimento=${id}`;
        console.log('🏪 [SECAO ITENS] Buscando produtos do estabelecimento:', id);
      } else {
        console.log('📦 [SECAO ITENS] Buscando todos os produtos');
      }

      const response = await fetch(url);
      if (!response.ok) throw new Error(`Erro do servidor: ${response.statusText}`);
      const data = await response.json();

      console.log('✅ [SECAO ITENS] Produtos carregados:', data.length);
      setProdutos(data);
    } catch (error) {
      console.error("❌ [SECAO ITENS] Erro ao buscar os produtos:", error.message);
    }
  };

  useEffect(() => {
    fetchProdutos();
  }, [id]); // Recarrega quando o id mudar

  const produtosFiltrados = produtos
    // Já vem filtrado do backend por estabelecimento
    .filter((produto) => produto.disponivel?.toLowerCase() === "sim")
    .filter((produto) =>
      categoriaSelecionada ? produto.categoria === categoriaSelecionada : true
    )
    .filter((produto) =>
      textoFiltrado
        ? produto.nome_item.toLowerCase().includes(textoFiltrado.toLowerCase())
        : true
    );

  return (
    <div className={styles.secaocompleta}>
      {produtos.length === 0 ? (
        <p>Carregando produtos...</p>
      ) : produtosFiltrados.length > 0 ? (
        produtosFiltrados.map((produto) => (
          <CardItem
            key={produto.id_item}
            id_item={produto.id_item}
            src={produto.imagem}
            label_title={produto.nome_item}
            p_descricao={produto.descricao}
            p_preco={`R$ ${parseFloat(produto.preco).toFixed(2)}`}
            id_estabelecimento={produto.id_estabelecimento}
            adicionarAoCarrinho={adicionarAoCarrinho}
            quantidade={produto.quantidade}
            hideAddBtn
          />
        ))
      ) : (
      <div className={styles.semProdutos}>
      <FaSearch className={styles.icon} />
      <p>Ops! Nenhum produto encontrado com esse nome.</p>
      <p>Tente buscar por outro item.</p>
    </div>
      )}
    </div>
  );
}

export default SecaoItens;
